export type OrgUnitKind = 'general' | 'planta' | 'sector' | 'proceso' | 'puesto';

export interface OrgUnitNode {
  id: string;
  parentId: string | null;
  kind: OrgUnitKind;
  name: string;
  code: string | null;
  location: string | null;
  active: boolean;
  children: OrgUnitNode[];
}

export interface OrgUnitPayload {
  parentId?: string | null;
  kind: OrgUnitKind;
  name: string;
  code?: string | null;
  location?: string | null;
}

export interface OrgUnitDependencies {
  studies: Array<{ id: string; code: string; title: string }>;
  risks: Array<{ id: string; code: string; title: string }>;
}

export const ORG_UNIT_KIND_LABEL: Record<OrgUnitKind, string> = {
  general: 'General',
  planta: 'Planta',
  sector: 'Sector',
  proceso: 'Proceso',
  puesto: 'Puesto',
};
